import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { ThirdPartyApiListResponse, ThirdPartyApiState, ThirdPartyApiSummary } from "./type";

const initialSummary: ThirdPartyApiSummary = {
  total: 0,
  healthy: 0,
  degraded: 0,
  down: 0,
};

const initialState: ThirdPartyApiState = {
  third_party_service_list: {
    total: 0,
    page: 1,
    page_size: 10,
    data: [],
  },
  third_party_service_summary: initialSummary,
  third_party_insurers: [],
  third_party_statuses: [],
};

const thirdPartyApiSlice = createSlice({
  name: "thirdPartyApi",
  initialState,
  reducers: {
    thirdPartyServiceList: (state, action: PayloadAction<ThirdPartyApiListResponse>) => {
      state.third_party_service_list = action.payload;

      if (action.payload.summary) {
        state.third_party_service_summary = action.payload.summary;
      }
    },

    thirdPartyServiceSummary: (state, action: PayloadAction<ThirdPartyApiSummary>) => {
      state.third_party_service_summary = action.payload;
    },

    setThirdPartyInsurers: (state, action: PayloadAction<any>) => {
      state.third_party_insurers = action.payload?.data || action.payload || [];
    },

    setThirdPartyStatuses: (state, action: PayloadAction<any>) => {
      state.third_party_statuses = action.payload?.labels || action.payload?.data?.labels || [];
    },
  },
});

export const {
  thirdPartyServiceList,
  thirdPartyServiceSummary,
  setThirdPartyInsurers,
  setThirdPartyStatuses,
} = thirdPartyApiSlice.actions;

export default thirdPartyApiSlice.reducer;
